import React from 'react';
import { Outlet } from 'react-router-dom';
import MasterTopbar from '@/components/layout/MasterTopbar';
import MasterSidebar from '@/components/layout/MasterSidebar';
import { MASTER_MAIN_CONTENT_ID } from '@/components/layout/master-layout-ids';

export default function MasterLayout() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-br dark:from-slate-950 dark:via-slate-900 dark:to-purple-950 transition-colors duration-300">
      {/* Background decoration - only visible in dark mode */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none dark:block hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-500/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 -left-40 w-80 h-80 bg-blue-500/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 right-1/3 w-80 h-80 bg-pink-500/10 rounded-full blur-3xl" />
      </div>
      
      {/* Content */}
      <div className="relative z-10 flex min-h-screen">
        <MasterSidebar />
        <div className="min-w-0 flex-1 overflow-x-hidden">
          <MasterTopbar />
          <main id={MASTER_MAIN_CONTENT_ID} tabIndex={-1} className="w-full px-4 py-6 outline-none sm:px-6 lg:px-8">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}



